import QuickLinksBlock from './QuickLinksBlock'
import QuickLinksCardBlock from './QuickLinksCardBlock'

export { QuickLinksBlock, QuickLinksCardBlock }
